import { ResourceRow } from './ResourceTabCard';
import { ResourceRequestItem } from 'components/IAP/hooks/incidentResourceRequestHooks';

export function resourceRequestItemToResourceRow(
  item: ResourceRequestItem
): ResourceRow {
  return {
    id: item.id ?? '',
    name: item.name ?? '',
    kind: item.kind,
    type: item.type,
    incident: undefined, // or map if you have incident info
    assignees: undefined,
    owning_organization: item.owning_organization,
    description: undefined,
    address: undefined,
    datetimeOrdered: item.requested_reporting_datetime, // or another relevant field
    pointOfContact: undefined,
    isTemplate: false, // or set as needed
  };
}
